/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as LicensesRouteImport } from "./routes/licenses"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated/index"
import { Route as AuthenticatedAdminRouteImport } from "./routes/_authenticated/admin"
import { Route as AuthenticatedClientsRouteImport } from "./routes/_authenticated/clients"
import { Route as AuthenticatedCollectionsRouteImport } from "./routes/_authenticated/collections"
import { Route as AuthenticatedCouponsRouteImport } from "./routes/_authenticated/coupons"
import { Route as AuthenticatedNotificationsRouteImport } from "./routes/_authenticated/notifications"
import { Route as AuthenticatedOffersRouteImport } from "./routes/_authenticated/offers"
import { Route as AuthenticatedOperatorsRouteImport } from "./routes/_authenticated/operators"
import { Route as AuthenticatedPromotionsRouteImport } from "./routes/_authenticated/promotions"
import { Route as AuthenticatedPurchasesRouteImport } from "./routes/_authenticated/purchases"
import { Route as AuthenticatedSettingsRouteImport } from "./routes/_authenticated/settings"
import { Route as AuthenticatedSubscriptionsRouteImport } from "./routes/_authenticated/subscriptions"
import { Route as AuthenticatedTagsRouteImport } from "./routes/_authenticated/tags"
import { Route as AuthenticatedTreatmentsRouteImport } from "./routes/_authenticated/treatments"
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback"
import { Route as AuthenticatedAdminIndexRouteImport } from "./routes/_authenticated/admin/index"
import { Route as AuthenticatedAdminHealthRouteImport } from "./routes/_authenticated/admin/health"
import { Route as AuthenticatedAdminOrgsIndexRouteImport } from "./routes/_authenticated/admin/orgs.index"
import { Route as AuthenticatedAdminOrgsIdRouteImport } from "./routes/_authenticated/admin/orgs.$id"
import { Route as AuthenticatedAdminSalonsIndexRouteImport } from "./routes/_authenticated/admin/salons.index"
import { Route as AuthenticatedAdminSalonsIdRouteImport } from "./routes/_authenticated/admin/salons.$id"

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const LicensesRoute = LicensesRouteImport.update({
  id: "/licenses",
  path: "/licenses",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientsRoute = AuthenticatedClientsRouteImport.update({
  id: "/clients",
  path: "/clients",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCollectionsRoute =
  AuthenticatedCollectionsRouteImport.update({
    id: "/collections",
    path: "/collections",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCouponsRoute = AuthenticatedCouponsRouteImport.update({
  id: "/coupons",
  path: "/coupons",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOffersRoute = AuthenticatedOffersRouteImport.update({
  id: "/offers",
  path: "/offers",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOperatorsRoute = AuthenticatedOperatorsRouteImport.update({
  id: "/operators",
  path: "/operators",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPromotionsRoute = AuthenticatedPromotionsRouteImport.update({
  id: "/promotions",
  path: "/promotions",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPurchasesRoute = AuthenticatedPurchasesRouteImport.update({
  id: "/purchases",
  path: "/purchases",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSubscriptionsRoute =
  AuthenticatedSubscriptionsRouteImport.update({
    id: "/subscriptions",
    path: "/subscriptions",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTagsRoute = AuthenticatedTagsRouteImport.update({
  id: "/tags",
  path: "/tags",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTreatmentsRoute = AuthenticatedTreatmentsRouteImport.update({
  id: "/treatments",
  path: "/treatments",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminHealthRoute =
  AuthenticatedAdminHealthRouteImport.update({
    id: "/health",
    path: "/health",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminOrgsIndexRoute =
  AuthenticatedAdminOrgsIndexRouteImport.update({
    id: "/orgs/",
    path: "/orgs/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminOrgsIdRoute =
  AuthenticatedAdminOrgsIdRouteImport.update({
    id: "/orgs/$id",
    path: "/orgs/$id",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSalonsIndexRoute =
  AuthenticatedAdminSalonsIndexRouteImport.update({
    id: "/salons/",
    path: "/salons/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSalonsIdRoute =
  AuthenticatedAdminSalonsIdRouteImport.update({
    id: "/salons/$id",
    path: "/salons/$id",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute
  "/licenses": typeof LicensesRoute
  "/login": typeof LoginRoute
  "/admin": typeof AuthenticatedAdminRouteWithChildren
  "/clients": typeof AuthenticatedClientsRoute
  "/collections": typeof AuthenticatedCollectionsRoute
  "/coupons": typeof AuthenticatedCouponsRoute
  "/notifications": typeof AuthenticatedNotificationsRoute
  "/offers": typeof AuthenticatedOffersRoute
  "/operators": typeof AuthenticatedOperatorsRoute
  "/promotions": typeof AuthenticatedPromotionsRoute
  "/purchases": typeof AuthenticatedPurchasesRoute
  "/settings": typeof AuthenticatedSettingsRoute
  "/subscriptions": typeof AuthenticatedSubscriptionsRoute
  "/tags": typeof AuthenticatedTagsRoute
  "/treatments": typeof AuthenticatedTreatmentsRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/admin/health": typeof AuthenticatedAdminHealthRoute
  "/admin/": typeof AuthenticatedAdminIndexRoute
  "/admin/orgs/$id": typeof AuthenticatedAdminOrgsIdRoute
  "/admin/salons/$id": typeof AuthenticatedAdminSalonsIdRoute
  "/admin/orgs/": typeof AuthenticatedAdminOrgsIndexRoute
  "/admin/salons/": typeof AuthenticatedAdminSalonsIndexRoute
}
export interface FileRoutesByTo {
  "/licenses": typeof LicensesRoute
  "/login": typeof LoginRoute
  "/clients": typeof AuthenticatedClientsRoute
  "/collections": typeof AuthenticatedCollectionsRoute
  "/coupons": typeof AuthenticatedCouponsRoute
  "/notifications": typeof AuthenticatedNotificationsRoute
  "/offers": typeof AuthenticatedOffersRoute
  "/operators": typeof AuthenticatedOperatorsRoute
  "/promotions": typeof AuthenticatedPromotionsRoute
  "/purchases": typeof AuthenticatedPurchasesRoute
  "/settings": typeof AuthenticatedSettingsRoute
  "/subscriptions": typeof AuthenticatedSubscriptionsRoute
  "/tags": typeof AuthenticatedTagsRoute
  "/treatments": typeof AuthenticatedTreatmentsRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/": typeof AuthenticatedIndexRoute
  "/admin/health": typeof AuthenticatedAdminHealthRoute
  "/admin": typeof AuthenticatedAdminIndexRoute
  "/admin/orgs/$id": typeof AuthenticatedAdminOrgsIdRoute
  "/admin/salons/$id": typeof AuthenticatedAdminSalonsIdRoute
  "/admin/orgs": typeof AuthenticatedAdminOrgsIndexRoute
  "/admin/salons": typeof AuthenticatedAdminSalonsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/licenses": typeof LicensesRoute
  "/login": typeof LoginRoute
  "/_authenticated/admin": typeof AuthenticatedAdminRouteWithChildren
  "/_authenticated/clients": typeof AuthenticatedClientsRoute
  "/_authenticated/collections": typeof AuthenticatedCollectionsRoute
  "/_authenticated/coupons": typeof AuthenticatedCouponsRoute
  "/_authenticated/notifications": typeof AuthenticatedNotificationsRoute
  "/_authenticated/offers": typeof AuthenticatedOffersRoute
  "/_authenticated/operators": typeof AuthenticatedOperatorsRoute
  "/_authenticated/promotions": typeof AuthenticatedPromotionsRoute
  "/_authenticated/purchases": typeof AuthenticatedPurchasesRoute
  "/_authenticated/settings": typeof AuthenticatedSettingsRoute
  "/_authenticated/subscriptions": typeof AuthenticatedSubscriptionsRoute
  "/_authenticated/tags": typeof AuthenticatedTagsRoute
  "/_authenticated/treatments": typeof AuthenticatedTreatmentsRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/_authenticated/": typeof AuthenticatedIndexRoute
  "/_authenticated/admin/health": typeof AuthenticatedAdminHealthRoute
  "/_authenticated/admin/": typeof AuthenticatedAdminIndexRoute
  "/_authenticated/admin/orgs/$id": typeof AuthenticatedAdminOrgsIdRoute
  "/_authenticated/admin/salons/$id": typeof AuthenticatedAdminSalonsIdRoute
  "/_authenticated/admin/orgs/": typeof AuthenticatedAdminOrgsIndexRoute
  "/_authenticated/admin/salons/": typeof AuthenticatedAdminSalonsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/licenses"
    | "/login"
    | "/admin"
    | "/clients"
    | "/collections"
    | "/coupons"
    | "/notifications"
    | "/offers"
    | "/operators"
    | "/promotions"
    | "/purchases"
    | "/settings"
    | "/subscriptions"
    | "/tags"
    | "/treatments"
    | "/auth/callback"
    | "/admin/health"
    | "/admin/"
    | "/admin/orgs/$id"
    | "/admin/salons/$id"
    | "/admin/orgs/"
    | "/admin/salons/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/licenses"
    | "/login"
    | "/clients"
    | "/collections"
    | "/coupons"
    | "/notifications"
    | "/offers"
    | "/operators"
    | "/promotions"
    | "/purchases"
    | "/settings"
    | "/subscriptions"
    | "/tags"
    | "/treatments"
    | "/auth/callback"
    | "/"
    | "/admin/health"
    | "/admin"
    | "/admin/orgs/$id"
    | "/admin/salons/$id"
    | "/admin/orgs"
    | "/admin/salons"
  id:
    | "__root__"
    | "/_authenticated"
    | "/licenses"
    | "/login"
    | "/_authenticated/admin"
    | "/_authenticated/clients"
    | "/_authenticated/collections"
    | "/_authenticated/coupons"
    | "/_authenticated/notifications"
    | "/_authenticated/offers"
    | "/_authenticated/operators"
    | "/_authenticated/promotions"
    | "/_authenticated/purchases"
    | "/_authenticated/settings"
    | "/_authenticated/subscriptions"
    | "/_authenticated/tags"
    | "/_authenticated/treatments"
    | "/auth/callback"
    | "/_authenticated/"
    | "/_authenticated/admin/health"
    | "/_authenticated/admin/"
    | "/_authenticated/admin/orgs/$id"
    | "/_authenticated/admin/salons/$id"
    | "/_authenticated/admin/orgs/"
    | "/_authenticated/admin/salons/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LicensesRoute: typeof LicensesRoute
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/licenses": {
      id: "/licenses"
      path: "/licenses"
      fullPath: "/licenses"
      preLoaderRoute: typeof LicensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/": {
      id: "/_authenticated/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/admin": {
      id: "/_authenticated/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/clients": {
      id: "/_authenticated/clients"
      path: "/clients"
      fullPath: "/clients"
      preLoaderRoute: typeof AuthenticatedClientsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/collections": {
      id: "/_authenticated/collections"
      path: "/collections"
      fullPath: "/collections"
      preLoaderRoute: typeof AuthenticatedCollectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/coupons": {
      id: "/_authenticated/coupons"
      path: "/coupons"
      fullPath: "/coupons"
      preLoaderRoute: typeof AuthenticatedCouponsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/notifications": {
      id: "/_authenticated/notifications"
      path: "/notifications"
      fullPath: "/notifications"
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/offers": {
      id: "/_authenticated/offers"
      path: "/offers"
      fullPath: "/offers"
      preLoaderRoute: typeof AuthenticatedOffersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/operators": {
      id: "/_authenticated/operators"
      path: "/operators"
      fullPath: "/operators"
      preLoaderRoute: typeof AuthenticatedOperatorsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/promotions": {
      id: "/_authenticated/promotions"
      path: "/promotions"
      fullPath: "/promotions"
      preLoaderRoute: typeof AuthenticatedPromotionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/purchases": {
      id: "/_authenticated/purchases"
      path: "/purchases"
      fullPath: "/purchases"
      preLoaderRoute: typeof AuthenticatedPurchasesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings": {
      id: "/_authenticated/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/subscriptions": {
      id: "/_authenticated/subscriptions"
      path: "/subscriptions"
      fullPath: "/subscriptions"
      preLoaderRoute: typeof AuthenticatedSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/tags": {
      id: "/_authenticated/tags"
      path: "/tags"
      fullPath: "/tags"
      preLoaderRoute: typeof AuthenticatedTagsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/treatments": {
      id: "/_authenticated/treatments"
      path: "/treatments"
      fullPath: "/treatments"
      preLoaderRoute: typeof AuthenticatedTreatmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/auth/callback": {
      id: "/auth/callback"
      path: "/auth/callback"
      fullPath: "/auth/callback"
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/admin/": {
      id: "/_authenticated/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/health": {
      id: "/_authenticated/admin/health"
      path: "/health"
      fullPath: "/admin/health"
      preLoaderRoute: typeof AuthenticatedAdminHealthRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/orgs/": {
      id: "/_authenticated/admin/orgs/"
      path: "/orgs"
      fullPath: "/admin/orgs/"
      preLoaderRoute: typeof AuthenticatedAdminOrgsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/orgs/$id": {
      id: "/_authenticated/admin/orgs/$id"
      path: "/orgs/$id"
      fullPath: "/admin/orgs/$id"
      preLoaderRoute: typeof AuthenticatedAdminOrgsIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/salons/": {
      id: "/_authenticated/admin/salons/"
      path: "/salons"
      fullPath: "/admin/salons/"
      preLoaderRoute: typeof AuthenticatedAdminSalonsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/salons/$id": {
      id: "/_authenticated/admin/salons/$id"
      path: "/salons/$id"
      fullPath: "/admin/salons/$id"
      preLoaderRoute: typeof AuthenticatedAdminSalonsIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminHealthRoute: typeof AuthenticatedAdminHealthRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminOrgsIdRoute: typeof AuthenticatedAdminOrgsIdRoute
  AuthenticatedAdminSalonsIdRoute: typeof AuthenticatedAdminSalonsIdRoute
  AuthenticatedAdminOrgsIndexRoute: typeof AuthenticatedAdminOrgsIndexRoute
  AuthenticatedAdminSalonsIndexRoute: typeof AuthenticatedAdminSalonsIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminHealthRoute: AuthenticatedAdminHealthRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminOrgsIdRoute: AuthenticatedAdminOrgsIdRoute,
  AuthenticatedAdminSalonsIdRoute: AuthenticatedAdminSalonsIdRoute,
  AuthenticatedAdminOrgsIndexRoute: AuthenticatedAdminOrgsIndexRoute,
  AuthenticatedAdminSalonsIndexRoute: AuthenticatedAdminSalonsIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedClientsRoute: typeof AuthenticatedClientsRoute
  AuthenticatedCollectionsRoute: typeof AuthenticatedCollectionsRoute
  AuthenticatedCouponsRoute: typeof AuthenticatedCouponsRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedOffersRoute: typeof AuthenticatedOffersRoute
  AuthenticatedOperatorsRoute: typeof AuthenticatedOperatorsRoute
  AuthenticatedPromotionsRoute: typeof AuthenticatedPromotionsRoute
  AuthenticatedPurchasesRoute: typeof AuthenticatedPurchasesRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedSubscriptionsRoute: typeof AuthenticatedSubscriptionsRoute
  AuthenticatedTagsRoute: typeof AuthenticatedTagsRoute
  AuthenticatedTreatmentsRoute: typeof AuthenticatedTreatmentsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedClientsRoute: AuthenticatedClientsRoute,
  AuthenticatedCollectionsRoute: AuthenticatedCollectionsRoute,
  AuthenticatedCouponsRoute: AuthenticatedCouponsRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedOffersRoute: AuthenticatedOffersRoute,
  AuthenticatedOperatorsRoute: AuthenticatedOperatorsRoute,
  AuthenticatedPromotionsRoute: AuthenticatedPromotionsRoute,
  AuthenticatedPurchasesRoute: AuthenticatedPurchasesRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedSubscriptionsRoute: AuthenticatedSubscriptionsRoute,
  AuthenticatedTagsRoute: AuthenticatedTagsRoute,
  AuthenticatedTreatmentsRoute: AuthenticatedTreatmentsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LicensesRoute: LicensesRoute,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
